'use strict';

angular.module('imagetrend.components')
    .directive('hlpLoading', [function () {
        return {
            restrict: 'AE',
            scope: {
                text: '@?',
                classes: '@?'
            },
            replace: true,
            templateUrl: 'templates/loading/loading.html',
            link: function (scope, elem, attrs, ctrl) {
                if (!attrs.text) { attrs.text = 'Loading'; }
                if (attrs.text == "NONE") { attrs.text = ""; }
            }
        };
    }])

;